import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { _className, Button, ComponentSync, openContent, stopPropagation } from '@nu-art/thunderstorm-frontend';
import { iconTooltipId } from '../../../_style/icon-tooltip/index.js';
import { ICONS } from '@app/styles';
import './Component_RefreshEncounter.scss';
export class Component_RefreshEncounter extends ComponentSync {
    //######################### Life Cycle #########################
    __onBackgroundTasksChanged = () => this.forceUpdate();
    __onReadOnlyChanged = () => this.forceUpdate();
    //######################### Logic #########################
    getTooltipMessage = () => {
        const hasBackgroundTasks = ModuleFE_EMInterface.hasBackgroundTasks();
        const isReadonly = ModuleFE_EMInterface.isReadonly();
        return (hasBackgroundTasks || isReadonly)
            ? 'Patient data loading'
            : 'Refresh data';
    };
    getClassName = () => {
        const hasBackgroundTasks = ModuleFE_EMInterface.hasBackgroundTasks();
        const isLoading = ModuleFE_EMInterface.isPatientDataLoading();
        return _className((hasBackgroundTasks || isLoading) && 'action-in-progress');
    };
    getDisabled = () => {
        const hasBackgroundTasks = ModuleFE_EMInterface.hasBackgroundTasks();
        const isReadonly = ModuleFE_EMInterface.isReadonly();
        return hasBackgroundTasks || isReadonly;
    };
    //######################### Render #########################
    render() {
        return _jsx("div", { className: 'c-refresh-encounter', ...openContent.tooltip.bottom(iconTooltipId, () => this.getTooltipMessage(), { offset: 8 }), children: _jsx(Button, { disabled: this.getDisabled(), variant: 'refresh-button', className: this.getClassName(), onClick: e => {
                    stopPropagation(e);
                    return ModuleFE_EMInterface.updateEncounterApis.refreshFhirData();
                }, children: _jsx(ICONS.sync.component, {}) }) });
    }
}
//# sourceMappingURL=Component_RefreshEncounter.js.map